import RemitFinancialInfoCard from './RemitFinancialInfoCard';

export default RemitFinancialInfoCard;
